<template>

        <el-drawer size="700px" title="选择优惠券" :visible.sync="drawerStatus"  id="addShop" @close='handleClose' :append-to-body="true">
            <!-- <el-radio-group v-model="curCardId" style="width:500px;margin:100px 100px;">
				<el-radio :label="item._no" v-for="(item,index) in list" :key="index" style="display: flex;height: 30px;">
					<div style="display: flex;justify-content: space-between;width:500px">
						<span>{{item.coupon_name}} ( {{item._no}} )</span>
						<span>{{$public.getDiscountType(item.apply_range.order_type)}}券</span>
						<span v-if="item.activity_type===1">
							满{{item.money_top}}元可用
						</span>
						<span v-if="item.activity_type===2">
							满{{item.rebate_top}}元可用，
							<span v-if="item.rebate_limit>0">最高抵扣{{item.rebate_limit}}元</span>
							<span v-else></span>
						</span>
					</div>
				</el-radio>
			</el-radio-group> -->
           <div style="margin:0 0 20px 30px;"> <el-input size="mini" style="width: 150px" v-model="scanningCodeInput" @keyup.enter.native="clickInput" clearable
                placeholder="请录入劵码">
            </el-input></div>
            <div style="margin:0 0 20px 30px;" >
                <div style="margin-bottom:20px;">
                    商品总金额：<span style="color:#FE2D2D">￥{{ money }}</span>
                </div>
                <div>
                    券后应付：<span style="color:#F5882A">￥{{ newMoney }}</span>
                </div>
            </div>
            <el-table :data="filtrateList.length!=0 ? filtrateList : list" style="height: 100%;" class="tableBox">
                <el-table-column label="优惠券名称">
                    <template slot-scope="scope">
                        <span>{{ scope.row.coupon_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="面额">
                    <template slot-scope="scope">
                        <span>{{ scope.row.money_reduce }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="核销码" width="110">
                    <template slot-scope="scope">
                        <el-radio v-model="radio" :label="scope.row._no" :disabled="isDisabled(scope.row)"
                            @change="changeRadio"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column label="使用规则" width="110">
                    <template slot-scope="scope">
                        满 {{ scope.row.money_top }} 减{{ scope.row.money_reduce }}
                    </template>
                </el-table-column>
                <el-table-column label="类别" width="130">
                    <template slot-scope="scope">
                        <span>{{ $public.getDiscountType(scope.row.apply_range.order_type) }}券</span>
                    </template>
                </el-table-column>
                <el-table-column label="有效期至" width="100">
                    <template slot-scope="scope">
                        {{ $public.FTime(scope.row.use_end_time, "YYYY-MM-DD") }}
                    </template>
                </el-table-column>
            </el-table>
            <div style="height: 80px;width:100%;"></div>
            <div class="btnBox">
                <div class="btnItem" @click="handleClose">取消</div>
                <div class="btnItem submit" @click="submitCode">确定</div>
            </div>
        </el-drawer>

</template>

<script>
export default {
    data() {
        return {
            drawerStatus: false,
            radio: '',
            curCard: {},
            list: [],
            newMoney: 0,
            scanningCodeInput: '',
            filtrateList:[]
        }
    },
    computed: {
    },
    props: {
        userId: {
            default: ''
        },
        state: {
            default: false
        },
        money: {
            default: 0
        },
        goodsList: {
            default: () => {
                return []
            }
        },
        type: {       // 1 商品 2 洗美 3 病例 4 疫苗驱虫 5 医疗服务套餐 6  寄养 7 挂号 8 活体 9 虚拟类 10 订金
            default: -1
        }
    },
    watch: {
        state(n) {
            this.drawerStatus = n;
            if (n) {
                this.getList()
                this.newMoney = this.money;
                this.radio = ''
                this.changeRadio();
            }
        }
    },
    mounted() {
    },
    methods: {
        // 筛选
        clickInput() {
            if (this.scanningCodeInput) {
                let value = this.scanningCodeInput
                let arr = this.list
                let filterArr = (arr, value) => {
                    return arr.filter(item => {
                        for (let key in item) {
                            if (item[key] === value) {
                                return true;
                            }
                        }
                        return false;
                    });
                }
                let result = filterArr(arr, value);
                this.filtrateList = result 
                if(this.filtrateList.length==0){
					this.$message({
          message: "未搜索到优惠券",
          type: "error",
        });
    }
            }
        },
        handleClose() {
            console.log(1111);
            this.$emit('submit', { type: 'close', card: this.curCard, newMoney: this.newMoney })
        },
        // 获取列表
        getList() {
            let params = {
                "memberId": this.userId,
                status: 1,  // -1:不限 0：不可用，1：未使用 2：已使用 3：已过期
                couponType: this.type,//  0不限 1. 商品  2.洗美  3.病例 4. 疫苗驱虫 5.医疗服务 6 寄养 7 挂号 8活体 9虚拟类 10定金 
                "pageIndex": 1,
                "pageSize": 1000,
            }
            this.list = []
            let loading = this.$loading()
            this.$http.get('/api/Member/CouponList', params).then(res => {
                loading.close()
                if (res.code == 0) {
                    let list = res.data.data;
                    console.log('优惠券列表', '11111');
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].apply_range !== null && list[i].apply_range.order_type !== null) {
                            if (list[i].apply_range.order_type.indexOf(this.type) > -1) {
                                this.list.push(list[i])
                            }
                        }

                    }
                }
            })
        },
        changeRadio() {
            this.curCard = this.$public.getMatchingItem(this.list, '_no', this.radio)
            this.newMoney = this.money;
            if (this.curCard.activity_type === 1) {
                this.newMoney = this.$public.jian(this.newMoney, this.curCard.money_reduce);
            } else if (this.curCard.activity_type === 2) {
                let yh = this.$public.cheng(this.newMoney, this.$public.jian(1, this.curCard.rebate));
                if (this.curCard.rebate_limit > 0) {
                    if (yh > this.curCard.rebate_limit) {
                        yh = this.curCard.rebate_limit
                    }
                }
                this.newMoney = this.$public.jian(this.newMoney, yh);
            } else if (this.curCard.activity_type === 3) {
                console.log(this.curCard.canList[0])
                this.newMoney = this.$public.jian(this.newMoney, this.curCard.canList[0].originalPrice);
            }
        },
        isDisabled(row) {
            if (row.activity_type === 1) { // 满减
                if (Number(this.money) < row.money_top) {
                    return true;
                }
            } else if (row.activity_type === 2) {  // 折扣
                if (Number(this.money) < row.rebate_top) {
                    return true;
                }
            } else if (row.activity_type === 3) {  // 抵扣
                let canUseGoods = row.voucher_detail.product_list;
                let canList = []
                for (let i = 0; i < canUseGoods.length; i++) {
                    let item1 = canUseGoods[i]
                    for (let a = 0; a < this.goodsList.length; a++) {
                        let item2 = this.goodsList[a]
                        if (item1.goods_id === item2.goodsId && item1.sku_id === item2.skus && item1.packing_way_id === item2.unitId) {
                            canList.push(item2)
                        }
                    }
                }
                if (canList.length === 0) {
                    return true;
                } else {
                    canList.sort(function (a, b) { return b.originalPrice - a.originalPrice });
                    row.canList = canList;
                }
            }
            return false;
        },
        submitCode() {
            console.log(this.curCard);
            console.log(this.newMoney);
            this.$emit('submit', { type: 'submit', card: this.curCard, newMoney: this.newMoney })
        },
    },
}
</script>

<style scoped lang="scss">
#addShop {
  ::v-deep .el-drawer__header {
    margin-bottom: 90px;
  }
  ::v-deep .el-drawer__body {
    height: calc(100% - 55px);
    overflow-y: auto;
  }
}


.btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;

    .tableBox {
        padding: 16px 16px 65px 16px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    overflow-x: hidden;	// 隐藏x轴滚动条
    overflow-y: auto;
    height: calc(100vh - 120px);	
    }
    .btnItem {
        text-align: center;
        width: 100%;
        background-color: #D6D6D6;
        cursor: pointer;

        &.submit {
            background-color: $mainColor;
        }
    }
}</style>
